<template>
  <div class="columns">
    <div class="column has-text-centered">
      <h1 class="is-size-4 red_text">קיימת התראה אדומה, האם לשלוח בכל מקרה ?</h1>
      <br />
      <h1 class="is-size-5">יש להתייעץ עם ראש האופרציה לפני ששולחים את קורות החיים האלו</h1>
      <br />
      <div class="red_container">
        <code style="word-wrap: break-word" v-for="(message, idx) in payload.addition_warnings" :key="idx">{{ message }}</code>
      </div>
      <br />
      <div v-if="Object.keys(payload.offer).length != 0" class="red_container">
        <CvColorAlertMessage :offer="payload.offer" :key="payload.offer.id" class="color_message_border" />
      </div>
      <br />
      <div class="columns">
        <div class="column">
          <button @click="submitResolve" class="button is-danger">שלח</button>
        </div>
        <div class="column">
          <button @click="submitReject" class="button is-info">אל תשלח</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import CvColorAlertMessage from '@/components/modals/CVColorAlertMessage'

export default {
  props: ['payload'],
  components: {
    CvColorAlertMessage
  },
  methods: {
    submitResolve () {
      this.remove(this.payload)
      this.payload.resolve()
    },
    submitReject () {
      this.remove(this.payload)
      this.payload.reject()
    },
    ...mapMutations('modals', ['remove'])
  }
}
</script>
<style scoped>
  .red_container {
    border: 1px solid red;
    border-radius: 3px;
    padding: 10px;
  }
  .color_message_border {
    margin-bottom: 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding-bottom: 10px;
  }
</style>
